// 引入lib-flexible库
(function flexible (window, document) {
    var docEl = document.documentElement
    var dpr = window.devicePixelRatio || 1
  
    // adjust body font size
    function setBodyFontSize () {
      if (document.body) {
        document.body.style.fontSize = (12 * dpr) + 'px'
      }
      else {
        document.addEventListener('DOMContentLoaded', setBodyFontSize)
      }
    }
    setBodyFontSize();
  
    // set 1rem = viewWidth / 10
    function setRemUnit () {
      // 原版：1rem = 屏幕宽度 / 10
      // 修改后：1rem = 屏幕宽度 / (设计稿宽度 / 10)
      var designWidth = 750; // 设计稿宽度（假设为750px）
      // var rem = docEl.clientWidth / (designWidth / 10); // 750px设计稿 → 1rem=10px
      var rem;

      if (docEl.clientWidth <= 480) {
        rem = docEl.clientWidth / (designWidth / 10);
      } else if (docEl.clientWidth <= 1024) {
        rem = docEl.clientWidth / (designWidth / 9);
      } else {
        rem = docEl.clientWidth / (designWidth / 3);
      }

      docEl.style.fontSize = rem + 'px';
    }
  
    setRemUnit()
  
    // reset rem unit on page resize
    window.addEventListener('resize', setRemUnit)
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) {
        setRemUnit()
      }
    })
  
    // detect 0.5px supports
    if (dpr >= 2) {
      var fakeBody = document.createElement('body')
      var testElement = document.createElement('div')
      testElement.style.border = '.5px solid transparent'
      fakeBody.appendChild(testElement)
      docEl.appendChild(fakeBody)
      if (testElement.offsetHeight === 1) {
        docEl.classList.add('hairlines')
      }
      docEl.removeChild(fakeBody)
    }
}(window, document))